export default "__VITE_ASSET__BiaQ2IzX__"